import { company, license } from 'app-support/company/state/reducer'
import { distributor, distributors } from 'app-support/licenses/state/reducer'
import region, { IRegionReducerState } from '../core/state/region/reducers'
import { shop, shops } from 'app-support/shops/state/reducer'

import { IShopByCompany } from '@cbgms/api'
import auth from 'app-support/auth/state/reducers'
import cache from 'app-support/cache/state/reducer'
import employee from 'app-support/employees/state/reducer'
import enums from 'enums/state/reducers'
import { reducer as form } from 'redux-form'
import productGroup from 'app-support/productgroup/state/reducers'
import { shopExternalSystems } from 'app-support/shops/components/ExternalSystems/state/reducer'
import theme from 'app-support/themes/state/reducer'
import wholesale from 'app-support/wholesale/state/reducers'
import stats from 'app-support/stats/state/reducer'

export interface IRootReducerState {
  auth: ReturnType<typeof auth>
  ou_name?: string
  AppId?: string
  company: any
  employee: ReturnType<typeof employee>
  enums: ReturnType<typeof enums>
  form: any
  productGroup: ReturnType<typeof productGroup>
  region: IRegionReducerState
  shop: any
  shops: IShopByCompany[]
  stats: ReturnType<typeof stats>
  theme: ReturnType<typeof theme>
  wholesale: ReturnType<typeof wholesale>
  distributors: ReturnType<typeof distributors>
  distributor: ReturnType<typeof distributor>
  license: ReturnType<typeof license>
  externalSystems: ReturnType<typeof shopExternalSystems>
}

const reducers = {
  auth,
  company,
  cache,
  employee,
  enums,
  form,
  productGroup,
  region,
  shop,
  shops,
  stats,
  wholesale,
  theme,
  distributors,
  distributor,
  license,
  externalSystems: shopExternalSystems
}

export default reducers
